/**
 * System Configuration
 * 시스템 관리 기능 설정 상수
 */

// ======== 권한 코드 ========

/** 권한 코드 상수 */
export const PRM_CODE = {
    /** 본사 */
    HEAD: 'C',
    /** 협력사 */
    SUPPLIER: 'S',
    /** 라이더 */
    RIDER: 'R',
    /** 관리자 */
    ADMIN: 'A',
    /** 협력사(대시보드) - 대시보드만 접근 가능 */
    SUPPLIER_ONLY_DASHBOARD: 'SOD',
} as const;

/** 권한 코드 라벨 매핑 */
export const PRM_CODE_LABEL: Record<string, string> = {
    [PRM_CODE.HEAD]: '본사',
    [PRM_CODE.SUPPLIER]: '협력사',
    [PRM_CODE.RIDER]: '라이더',
    [PRM_CODE.ADMIN]: '관리자',
    [PRM_CODE.SUPPLIER_ONLY_DASHBOARD]: '협력사(대시보드)',
};

/**
 * 권한 코드로 라벨 반환
 * @param prmCode 권한 코드
 * @returns 권한 라벨
 */
export const getPrmCodeLabel = (prmCode: string): string => {
    return PRM_CODE_LABEL[prmCode] || prmCode;
};

// ======== 사용자 타입 ========

/** 사용자 타입 상수 (비즈니스 로직용) */
export const USER_TYPE = {
    /** 관리자 */
    ADMIN: 'A',
    /** 본사 */
    HEAD: 'C',
    /** 협력사 */
    SUPPLIER: 'S',
    /** 라이더 */
    RIDER: 'R',
} as const;

/** 사용자 타입 라벨 매핑 */
export const USER_TYPE_LABEL: Record<string, string> = {
    [USER_TYPE.ADMIN]: '관리자',
    [USER_TYPE.HEAD]: '본사',
    [USER_TYPE.SUPPLIER]: '협력사',
    [USER_TYPE.RIDER]: '라이더',
};

/**
 * 사용자 타입으로 라벨 반환
 * @param userType 사용자 타입
 * @returns 사용자 타입 라벨
 */
export const getUserTypeLabel = (userType: string | null): string => {
    if (!userType) return '-';
    return USER_TYPE_LABEL[userType] || userType;
};

// ======== 사용 여부 ========

/** 사용 여부 상수 */
export const USE_YN = {
    /** 사용 */
    YES: 'Y',
    /** 미사용 */
    NO: 'N',
} as const;

/** 사용 여부 라벨 매핑 */
export const USE_YN_LABEL: Record<string, string> = {
    [USE_YN.YES]: '사용',
    [USE_YN.NO]: '미사용',
};

/**
 * 사용 여부로 라벨 반환
 * @param useYn 사용 여부
 * @returns 사용 여부 라벨
 */
export const getUseYnLabel = (useYn: string): string => {
    return USE_YN_LABEL[useYn] || useYn;
};

// ======== 스토리지 키 ========

/** 시스템 관리 localStorage 키 */
export const SYSTEM_STORAGE_KEYS = {
    /** 사용자 관리 필터 */
    USER_MANAGEMENT_FILTERS: 'userManagementFilters',
    /** 공통코드 수정 모드 */
    COMMON_CODE_EDIT_MODE: 'COMMON_CODE_EDIT_MODE',
    /** 공통코드 수정 그룹코드 */
    COMMON_CODE_EDIT_GRP_CODE: 'COMMON_CODE_EDIT_GRP_CODE',
} as const;

// ======== 페이지네이션 ========

/** 사용자 관리 페이지당 항목 수 */
export const USER_ITEMS_PER_PAGE = 15;

// ======== 이벤트 ========

/** 대시보드 이벤트 키 */
export const DASHBOARD_EVENTS = {
    /** 페이지 이동 */
    NAVIGATE: 'dashboard:navigate',
    /** 탭 닫기 */
    CLOSE_TAB: 'dashboard:close-tab',
    /** 공통코드 새로고침 */
    COMMON_CODE_REFRESH: 'common-code:refresh',
} as const;

// ======== 탭 ID ========

/** 시스템 탭 ID */
export const SYSTEM_TAB_IDS = {
    /** 공통코드 관리 */
    COMMON_CODE: 'common_code',
    /** 공통코드 추가 */
    COMMON_CODE_ADD: 'common_code_add',
} as const;
